import API from "store/api"
import serialize from "store/serialize"
import { updateLoggedInUser } from "./authentication"
import { setIsLoading } from "../actions/isLoading"

// getuser method loads user data for a given user id
export const getUser = (id, token) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      API.get(`/users/${id}`)
        .set({ Authorization: token })
        .then(response => {
          return response.body
        })
        .then(response => {
          if (response.user) {
            serialize("user", response.user)
              .then(response => {
                resolve(response)
              })
              .catch(err => {
                reject(err)
              })
          } else {
            reject("not found")
          }
        })
        .catch(err => {
          reject(err)
        })
    })
    return deferred
  }
}

// updateUser method updates user data for a given user id
export const updateUser = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      // Checks if profileImage is from cloudinary by checking path ie: has "profile/". If so delete from object
      if (data.profileImage.split("/")[0] === "profile") {
        delete data.profileImage
      }
      API.put(`/users`)
        .send(data)
        .then(response => response.body)
        .then(response => {
          // console.log("RES:", response)
          if (response.message === "User updated") {
            const profileImage =
              response.data.profile_image &&
              JSON.parse(response.data.profile_image).public_id
            const additionalFields = Object.keys(response.additionalFields).map(
              key => {
                return {
                  field_id: response.additionalFields[key].id,
                  name: response.additionalFields[key].name,
                  value: response.additionalFields[key].value
                }
              }
            )

            /* eslint-disable */
            const userData = response.data.profile_image
              ? {
                  ...response.data,
                  additionalFields: additionalFields,
                  profile_image: profileImage
                }
              : {
                  ...response.data,
                  additionalFields: additionalFields
                }
            /* eslint-enable */

            dispatch(
              updateLoggedInUser({
                ...userData,
                needs_new_password: false
              })
            )
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
    return deferred
  }
}

export const addOrg = code => {
  return dispatch => {
    dispatch(setIsLoading(true))
    const deferred = new Promise((resolve, reject) => {
      API.post(`/users/join/`)
        .send({ code })
        .then(response => response.body)
        .then(response => {
          dispatch(setIsLoading(false))
          return resolve(response)
        })
        .catch(error => reject(new Error(error)))
    })
    return deferred
  }
}

export const userExists = phone => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.get(`/users/phone/${phone}`)
      .then(response => response.body)
      .then(resolve)
      .catch(reject)
  })
  return deferred
}

export const checkForUser = phoneNumber => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.get(`/users/search/${phoneNumber}`)
      .then(res => {
        return res.body
      })
      .then(res => resolve(res))
      .catch(error => reject(error))
  })
  return deferred
}

export const inviteUser = phoneNumber => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/users/invite/${phoneNumber}`)
      .then(res => {
        return res.body
      })
      .then(res => resolve(res))
      .catch(error => reject(error))
  })
  return deferred
}

export const resetPassword = data => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/users/reset/`)
      .send(data)
      .then(res => {
        return res.body
      })
      .then(res => resolve(res))
      .catch(error => reject(error))
  })
  return deferred
}

export const getMagicLink = id => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.get(`/users/magic_link/${id}`)
      .then(res => {
        return res.body
      })
      .then(res => resolve(res))
      .catch(error => reject(error))
  })
  return deferred
}



// WEBPACK FOOTER //
// ./src/actions/user.js